exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".reactions-form {\n  margin: 40px 0 20px 0;\n}\n.reactions-form .btn {\n  min-width: 4rem;\n  font-size: 18px;\n  margin-right: 5px;\n}\n.reactions-form .btn span {\n  font-size: 12px;\n}", ""]);

// exports
